/* Step 2 "Fill your box" - mobile Uniform Swatch Row enhancer (2026-06-18).
   On a mobile viewport only: injects a compact "Fill your box / Step 2 of 2"
   header, a bottom-right +/check add button on each card, and a UNIFORM swatch
   row (multi-variant -> existing colour dots + kind label; single-variant ->
   one category dot + category word). Desktop DOM is never mutated (run() bails
   above 768px); injected nodes are inert on desktop via gb-builder-4-step2-mobile.css. */
(function(){
  var MQ = window.matchMedia('(max-width: 768px)');

  // category -> [label word, dot colour] for single-variant uniform dot
  var CAT = {
    treats:      ['treat',    '#a85e38'],
    wellness:    ['wellness', '#2d6b5e'],
    comfort:     ['comfort',  '#c9b9a6'],
    candles:     ['candle',   '#c89a6a'],
    connection:  ['personal', '#b08456'],
    accessories: ['travel',   '#c19a6b']
  };
  // kind word for true multi-variant products (default 'colour')
  var KIND = { candle_prem:'scent', candle_cc:'scent', candle_cube:'colour', passport:'colour',
               art_print:'design', pickle:'character', bath_soak_test_tube:'scent' };
  // single-variant products that DO have a meaningful kind:value + dot colour

  function shortName(s){ return (s||'').split(/\s+[-\u2013\u2014\/]\s+/)[0].trim(); }

  function enhanceCard(card){
    if (card.dataset.uniDone === '1') return;
    var img  = card.querySelector('.gb-prod-img');
    var info = card.querySelector('.gb-prod-info');
    if (!img || !info) return;

    // restore the FULL product title if the SSR text was truncated (…)
    var nameEl = card.querySelector('.gb-prod-name');
    if (nameEl && card.dataset.name && /(…|\.\.\.)\s*$/.test(nameEl.textContent)) {
      nameEl.textContent = card.dataset.name;
    }

    if (!img.querySelector('.gb-uni-add')) {
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'gb-uni-add';
      add.setAttribute('aria-label', 'Add to box');
      add.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();   // add directly, don't open the detail sheet
        if (window.gbQuickAdd) window.gbQuickAdd(card);
        else if (window.gbToggleProduct) window.gbToggleProduct(card);
      });
      img.appendChild(add);
    }

    if (!info.querySelector('.gb-uni-vrow')) {
      var cat  = card.dataset.cat || '';
      var row  = card.querySelector('.gb-variant-row');
      var vrow = document.createElement('div');
      vrow.className = 'gb-uni-vrow';

      if (row && row.querySelector('.gb-swatch.gb-swatch-color')) {
        var kind = KIND[card.dataset.id] || 'colour';
        var lab  = document.createElement('div');
        lab.className = 'gb-uni-lab';
        var labVal = document.createElement('b');
        lab.appendChild(document.createTextNode(kind + ': '));
        lab.appendChild(labVal);
        // Follow the card's CURRENT variant: swatch taps (gbSelectSwatch) and the
        // detail sheet both write data-variant-name, so observe that one attribute.
        var syncLab = function(){
          var sw = row.querySelector('.gb-swatch.selected') || row.querySelector('.gb-swatch');
          labVal.textContent = shortName(card.dataset.variantName ||
            (sw && (sw.getAttribute('data-variant-name') || sw.getAttribute('aria-label')))) || 'Choose';
        };
        syncLab();
        if (window.MutationObserver) new MutationObserver(syncLab).observe(card, { attributes: true, attributeFilter: ['data-variant-name'] });
        vrow.appendChild(lab);
        vrow.appendChild(row);              // move existing colour dots into the wrapper
        info.appendChild(vrow);
      } else {
        if (row) row.classList.add('gb-uni-rowhidden');  // unmapped text-chip row -> hide on mobile
        vrow.className = 'gb-uni-vrow gb-uni-solo';
        var kw, sval, col;
        var meta = CAT[cat] || ['gift', '#c19a6b']; kw = meta[0]; col = meta[1];
        sval = row && row.querySelector('.gb-swatch') ? shortName(card.dataset.variantName ||
          ((row.querySelector('.gb-swatch.selected') || {}).getAttribute ? row.querySelector('.gb-swatch.selected').getAttribute('data-variant-name') : '')) : '';
        var dot = document.createElement('span'); dot.className = 'gb-uni-dot'; dot.style.background = col;
        var word = document.createElement('span'); word.className = 'gb-uni-soloword';
        word.innerHTML = sval ? (kw + ' : <b>' + sval + '</b>') : kw;
        vrow.appendChild(dot); vrow.appendChild(word);
        info.appendChild(vrow);
      }
    }
    card.dataset.uniDone = '1';
  }

  function injectHeader(){
    var byo = document.getElementById('gb-byo-products');
    if (!byo || byo.querySelector('.gb-uni-headwrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'gb-uni-headwrap';
    wrap.innerHTML =
      '<div class="gb-uni-nav">' +
        '<button type="button" class="gb-uni-back" aria-label="Change box">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>' +
        '</button>' +
        '<h2 class="gb-uni-title">Fill your <em>box</em></h2>' +
        '<span class="gb-uni-step">2 / 2</span>' +
      '</div>';
    var backBtn = wrap.querySelector('.gb-uni-back');
    if (backBtn) backBtn.addEventListener('click', function(){ if (window.gbShowTiers) window.gbShowTiers(); });
    byo.insertBefore(wrap, byo.firstChild);
  }

  function run(){
    if (!MQ.matches) return;
    try {
      injectHeader();
      var grid = document.getElementById('gb-product-grid');
      if (grid) Array.prototype.forEach.call(grid.querySelectorAll('.gb-product-card'), enhanceCard);
    } catch (e) { /* never break the builder */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  if (MQ.addEventListener) MQ.addEventListener('change', run);
  else if (MQ.addListener) MQ.addListener(run);
  window.gbUniformMobileRows = run;
})();
